import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { persistor, store } from 'store';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FirebaseProvider } from 'contexts/FirebaseAuthContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <FirebaseProvider>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <App />
          <ToastContainer position='top-right' theme='colored' hideProgressBar={true} autoClose={2000} />
        </BrowserRouter>
      </FirebaseProvider>
    </PersistGate>
  </Provider>
);